import { Injectable, Injector, OnDestroy } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { Router } from '@angular/router';

@Injectable()
export class JWTInterceptor implements HttpInterceptor, OnDestroy {
  token: NbAuthJWTToken;
  subscription: Subscription;
  constructor(private authService: NbAuthService, private router: Router, private injector: Injector) { 
    this.subscription = this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
      this.token = token;
    })
  }
  
  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.token.getValue()}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !request.url.includes('/auth/login')) {
          return this.authService.refreshToken('email').pipe(
            switchMap(() => {
              if (this.token) {
                request = request.clone({
                  setHeaders: {
                    Authorization: `Bearer ${this.token.getValue()}`
                  }
                });
                return next.handle(request);
              }
              return throwError(error);
            }),
            catchError((err) => {
              console.log(err);
              this.router.navigate(["/auth/login"], { queryParams: { expired: true } });
              return throwError('Token refresh time to live expired.');
            })
          );
        }
        return throwError(error);
      })
    );
  }
}
